<template>
  <div class="post">
    <div class="post-detail" v-if="postDetail && postDetail.id">
      <h1 class="post-detail-title">
        <span>{{ postDetail.name }} </span>

        <ghidri-back />
      </h1>

      <div class="post-detail-subTitle">
        <span>{{ postDetail.categoryTimeName }}</span>

        <span style="margin: 0px 5px;" v-if="postDetail.deadline">|</span>
        <span v-if="postDetail.deadline">{{ postDetail.deadline }}</span>
      </div>

      <div class="post-detail-description post-detail-block" v-if="postDetail.majorTarget">
        <h2>专业方向</h2>
        <pre class="textContent">{{ postDetail.majorTarget }}</pre>
      </div>

      <div class="post-detail-description post-detail-block" v-if="postDetail.majorType">
        <h2>专业类别</h2>
        <pre class="textContent">{{ postDetail.majorType }}</pre>
      </div>

      <div class="post-detail-requirement post-detail-block">
        <h2>课题单位</h2>
        <div class="orgn-list">
          <span>{{ postDetail.deptName }}</span>
        </div>
      </div>

      <div class="post-detail-block">
        <ghidri-button size="large" class="post-detail-button apply" @click="toCartBeforeEvent">投递简历</ghidri-button>
      </div>
    </div>

    <div class="post-detail" v-else>
      <ghidri-empty>
        <span>暂无数据</span>
        <el-button icon="el-icon-back" type="text" @click="backEvent">点击返回</el-button>
      </ghidri-empty>
    </div>
  </div>
</template>

<script>
  import doctorPostApi from "@/api/doctor/doctorPost.js";

  export default {
    name: "DoctorPostDetail",
    components: {
    },
    data() {
      return {
        postDetail: {},
      };
    },
    created() {
      const id = this.$route.params.id
      this.init(id);
    },
    methods: {
      init(id) {
        const _this = this;
        if (id != null && typeof (id) != 'undefined' && id != '') {
          let loading = _this.$loading({ position: { top: 60 } });
          doctorPostApi.getPostById(id).then(res => {
            if (res.success) {
              _this.postDetail = res.data;
            }
            loading.close();
          }).catch(loading.close);
        }
      },

      toCartBeforeEvent() {
        this.$router.push({ path: "/doctor/cartBefore/" + this.postDetail.id });
      },

      //返回
      backEvent() {
        this.$router.go(-1);
      }

    }
  };
</script>

<style lang="less" scoped>
  .post {
    .post-detail {
      min-height: calc(100vh - 400px);
      width: 800px;

      margin: auto;
      margin-top: 30px;
      line-height: 2em;

      box-shadow: 0px 9px 20px 0px #c2c1c180;
      border-radius: 4px;
      padding: 30px;

      &-subTitle {
        font-size: @font-size-base;
        color: @primary-text-color;
        margin: 10px 0;
      }

      &-description {
        .textContent {
          white-space: pre-line;
        }
      }

      &-block {
        h2 {
          margin-bottom: 20px;

          border-left: 3px solid #014fa2;
          line-height: 1;
          padding-left: 10px;
        }
        margin: 40px 0;

        .orgn-list {
        }

        .textContent {
          font-size: @font-size-base;
          color: @primary-text-color;
        }
      }

      &-button {
        display: inline-flex;
        width: 200px;
      }

      .add-cart {
        float: left;
      }

      .apply {
        float: right;
      }
    }
  }
</style>
